'use strict';

import { HotbarComponentFactory as h } from 'hotdamnbar/factory';

const CurrenciesPrMonthHotbarReport = h.hotbar('currenciesPrMonthHotbarReportHotbar');

CurrenciesPrMonthHotbarReport.add(h.singleDate('Date', true));

export default CurrenciesPrMonthHotbarReport;